<template lang="html">
        <div class="embed-responsive embed-responsive-4by3">
      <iframe
        class="embed-responsive-item"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2747.3546775469135!2d3.9718843159082695!3d46.481288979126084!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47f3dfa18a315641%3A0xfb70a3163a4595a6!2s11%20Rue%20de%20la%20Dombe%2C%2071160%20Digoin!5e0!3m2!1sfr!2sfr!4v1621287466501!5m2!1sfr!2sfr"></iframe>
    </div>
</template>
<script>
export default {
  name: "Map",
};
</script>
<style lang="css">
@media (min-width: 576px) {
  .embed-ex {
    padding: 1.5rem;
    margin-right: 0;
    margin-left: 0;
    border-width: 0.2rem;
  }
}

@media (max-width: 576px) {
  .embed-responsive {
    width: 100% !important;
  }
}

.embed-ex {
  padding: 1.5rem;
  margin-right: 0;
  margin-left: 0;
  border-width: 0.2rem;
}
 </style>
 <style lang="scss">
// Credit: Nicolas Gallagher and SUIT CSS.
.embed-responsive {
  position: relative;
  display: block;
  border-radius: 10px;
  width: 65%;
  max-height: 500px;
  padding: 0;
  overflow: hidden;

  &::before {
    display: block;
    content: "";
  }

  .embed-responsive-item,
  iframe,
  embed,
  object,
  video {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
}

.embed-responsive-4by3 {
  &::before {
    padding-top: percentage(3 / 4);
  }
}
</style>